import React, { useState } from 'react'


interface CardHelpProps{
    title: string
    , text : string
}
const CardHelp = ({title, text} : CardHelpProps) => {

    const [open, setOpen] = useState<Boolean>(false)

    return (
        <div className="acc-b">
        <button
          type="button"
          className= {`acc-b__header ${open?"selected":""}`}
          aria-controls="acc-h1"
          onClick = { () => setOpen(!open)}
        >
          <span className="acc-b__header-qa">
            <span className="acc-b__header-q">{title}</span>
          </span>
        </button>
        <div id="acc-h1" className="acc-b__content">
          {text}
        </div>
      </div>
    )
}

export default CardHelp
